import WebsiteSettingsContainer from './website-settings-container';

export default {
  WebsiteSettingsContainer,
};
